export const routesList = {
  APPLICATION_FEE_INTRO: '/units/:unitId/apply_fee_intro',
  APPLICATION_SUBMITTED: '/:applicationId/application-submitted',
  BUILDING_DETAILS: '/buildings/:id',
  BUILDING_UNITS: '/buildings/:buildingId/units',
  HOME: '/home',
  LEASE_APPLICATION: '/units/:unitId/apply/:step',
  PHONE_VERIFICATION: '/verification',
  RENTAL_APPLICATION_START: '/units/:unitId/apply',
  REPORTS: '/units/:unitId/applications/:applicationId/reports',
  SEARCH_BUILDINGS_RESULTS: '/buildings/results',
  SEARCH_UNITS: '/units/search',
  SEARCH_UNITS_RESULTS: '/units/search/:criteria',
  SIGN_UP: '/sign-up',
  SUGGESTED_BUILDINGS: '/buildings/:buildingId/suggested_buildings',
  UNIT_DETAILS: '/buildings/:buildingId/units/:id',
};

export type AppRoute = keyof typeof routesList;

export default routesList;
